module.exports = __webpack_public_path__ + "img/l10.6226d782.svg";